/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoFusionModelsUserBlankListItem,
    SharedserviceMelcoFusionModelsUserBlankListItemFromJSON,
    SharedserviceMelcoFusionModelsUserBlankListItemFromJSONTyped,
    SharedserviceMelcoFusionModelsUserBlankListItemToJSON,
    SharedserviceMelcoModelsCustomWarning,
    SharedserviceMelcoModelsCustomWarningFromJSON,
    SharedserviceMelcoModelsCustomWarningFromJSONTyped,
    SharedserviceMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem
 */
export interface SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem {
    /**
     * 
     * @type {Array<SharedserviceMelcoFusionModelsUserBlankListItem>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem
     */
    list: Array<SharedserviceMelcoFusionModelsUserBlankListItem>;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsCustomWarning>}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem
     */
    warning_list?: Array<SharedserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem
     */
    total: number;
}

export function SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItemFromJSON(json: any): SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem {
    return SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItemFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(SharedserviceMelcoFusionModelsUserBlankListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(SharedserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItemToJSON(value?: SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(SharedserviceMelcoFusionModelsUserBlankListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(SharedserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


